function initHeader() {
  const headerBurger = document.querySelector('.header__burger')
  const header = document.querySelector('.header')
  const headerMobileMenuClose = document.querySelector('.header__mobile-menu-close')

  if (headerBurger) {
    headerBurger.addEventListener('click', () => {
      header.classList.add('is-active')
    })
  }

  if (headerMobileMenuClose) {
    headerMobileMenuClose.addEventListener('click', () => {
      header.classList.remove('is-active')
    })
  }
}

export { initHeader }